import { ref, type App } from 'vue'
import * as Sentry from '@sentry/browser'

type AB = ReturnType<typeof initAb>

interface CustomEventMap {
  'ab:init': CustomEvent<string>
}

declare global {
  interface Window {
    __ab: Array<string> | AB
  }
  interface Document {
    addEventListener<K extends keyof CustomEventMap>(type: K, listener: (this: Document, event: CustomEventMap[K]) => void): void
    dispatchEvent<K extends keyof CustomEventMap>(event: CustomEventMap[K]): void
  }
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $ab: AB
  }
}

const initAb = () => {

  const tests = ref<string[]>([])

  const includes = (test: string) => tests.value.includes(test)

  const push = (test: string) => {
    if (includes(test)) {
      return
    }
    tests.value.push(test)
    document.body.classList.add(`ab__${test}`)
    Sentry.setTag('ab', test)
  }

  if (window.location.href.includes('ab=')) {
    const params = new URLSearchParams(window.location.search)
    String(params.get('ab')).split(',').forEach((test) => push(test))
  }

  return {
    tests,
    includes,
    push
  }
}

export const abPlugin = {
  install(app: App) {
    const ab = initAb()
    // check for any AB tests that were activated before this plugin loads, then hijack the __ab object
    if (Array.isArray(window.__ab)) {
      window.__ab.forEach((test) => ab.push(test))
      window.__ab = ab
    }
    app.config.globalProperties.$ab = ab
  }
}

export default abPlugin
